<template>
  <div class="more-text por">
    <div class="poa no-show" ref="textHeight">{{text}}</div>
    <div class="poa no-show" :class="'wot' + rRow" ref="needHeight">{{text}}</div>
    <div class="poa no-show" :class="'wot' + (rRow - 1 || 1)" ref="prevHeight">{{text}}</div>
    <div :class="{'por end-length': endLength}" ref="show">
      <div class="prev-row ovh">{{prevRow}}</div>
      <div class="last-row flex" v-show="show">
        <div class="inner w50 wot1" :style="{width: lastWidth + '%'}">{{moreRow}}</div>
        <div class="more flex aic csp curr-ico down wsnw" @click="getMore">
          <span>{{endLength ? '收起' : '查看全部'}}</span>
          <!--<img src="../images/more-to-right.png" class="img">-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MoreText',
    props: {
      row: String | Number,
      text: {
        type: String,
        required: true
      },
      lastWidth: Number | String,
      noChange:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        prevHeight: '',
        textHeight: '',
        needHeight: '',
        min: 0,
        max: 0,
        length: 0,
        endLength: 0,
      };
    },
    watch: {
      text() {
        this.initHeight();
      },
      row() {
        this.initHeight();
      },
      show(val){
        this.$emit('show-more',val);
      }
    },
    computed: {
      prevRow() {
        return this.text.slice(0, this.length);
      },
      moreRow() {
        return this.text.slice(this.length);
      },
      rRow() {
        return Math.min(5, Math.max(1, +this.row));
      }
    },
    created() {
      this.initHeight();
    },
    mounted() {
      this.initHeight();
    },
    methods: {
      getMore() {
        if (this.$listeners.more) {
          this.$emit('more', this.length);
        } else if (this.endLength) {
          this.length = this.endLength;
          this.endLength = 0;
        } else {
          this.endLength = this.length;
          this.length = this.text.length;
        }
      },
      lengthChange() {
        let {length, needHeight: need, textHeight: text, prevHeight: prev} = this;
        this.$nextTick(e => {
          let {height} = this.$refs.show.getBoundingClientRect();
          if (length === this.text.length) {
            length = (length * prev / text) | 0;
          } else if (height - need > 3) {
            this.max = length;
            length--;
          } else {
            this.min = length;
            if (this.max - this.min !== 1 && need - height > 3) {
              length++;
            }
          }
          if (this.length !== length) {
            this.length = length;
            this.lengthChange();
          } else {
            this.$emit('end', this.length);
          }
        });
      },
      initHeight() {
        this.length = this.text.length;
        this.max = this.length;
        this.min = 0;
        this.$nextTick(() => {
          if (this.$refs.needHeight && this.$refs.textHeight && this.$refs.prevHeight) {
            this.needHeight = this.$refs.needHeight.offsetHeight;
            this.textHeight = this.$refs.textHeight.offsetHeight;
            this.prevHeight = this.$refs.prevHeight.offsetHeight;
            this.show = this.needHeight < this.textHeight;
            !this.noChange && this.show && this.lengthChange();
          }
        });
      }
    }
  };
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  .curr-ico {
    .spirit-mask(url(../../assets/images/home_icon.png));
    &.down {
      &:after {
        margin-left: 4px;
        width: 11px;
        height: 7px;
        mask-position: -11px -16px;
        background-color: #999FA6;
      }
    }
  }

  .more {
    margin-left: 2em;
    color: #999fa6;
    &:hover {
      color: #1177ff;
      &.down {
        &:after {
          background-color: #1177ff;
        }
      }
    }
  }

  .end-length {
    .last-row {
      .more {
        margin-left: auto;
      }
    }
    .down {
      &:after {
        transform: rotateX(180deg);
      }
    }
  }

  .no-show {
    opacity: 0;
    left: -200%;
    width: 100%;
  }
</style>
